import script from "./PrinterGlobal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrinterGlobal.vue?vue&type=script&setup=true&lang=js"

import "./PrinterGlobal.vue?vue&type=style&index=0&id=b6b5bff0&lang=css"

const __exports__ = script;

export default __exports__